/** The active-business cookie, read and written on the client. Shared by the sidebar (which switches it) and Smithers' panel (which scopes its badge by it). */
/** Keep in sync with BUSINESS_COOKIE in lib/businesses.ts. */
const BUSINESS_COOKIE = "caw_business";

export function readBusinessCookie(): string {
  const match = document.cookie.match(
    new RegExp(`(?:^|; )${BUSINESS_COOKIE}=([^;]*)`)
  );
  return match ? decodeURIComponent(match[1]) : "";
}

export function writeBusinessCookie(id: string) {
  document.cookie = `${BUSINESS_COOKIE}=${encodeURIComponent(id)}; path=/; max-age=31536000`;
}
